/**
 * DeviceCard.jsx (868m4jf4v)
 *
 * Thin wrapper around the existing .card primitive (components/design-
 * system.css) -- background: var(--bg-surface), border: var(--border),
 * border-radius: var(--radius-lg), box-shadow: var(--shadow-sm), all
 * theme-aware for free. Reconciles the several ad hoc `background:
 * '#131B2E', border: '1px solid #1E293B', borderRadius: 12` (and 14, and
 * 10 -- three slightly different hand-picked radii for the same "this is
 * a card" intent) blocks scattered across MdSwitchDetail.jsx and
 * MdRouterDetail.jsx onto one real, themed treatment.
 *
 * Replaces: the front panel wrapper, the port-loading placeholder, the
 * port table wrapper, the port detail drawer's stat/device panels, the
 * environment card, and the router page's WAN link cards.
 *
 * className/style pass through so a caller can still add a responsive
 * gating class (e.g. "switch-front-panel") or a semantic override (e.g. a
 * WAN link's status-colored border) on top of the shared base.
 */

export default function DeviceCard({ className, style, children, ...rest }) {
  return (
    <div className={['card', className].filter(Boolean).join(' ')} style={style} {...rest}>
      {children}
    </div>
  );
}
